import { IEventrTransport, IOptionsWithTypes } from '@eventr/common'

export const getAllPeople = (trans: IEventrTransport) => {
    const all: IOptionsWithTypes[] = []
    trans?.passengers_list?.forEach((p) => {
        all.push(...p.users)
    })
    return all
}
